<template>
    <div class="portfolio-overview-page">
        <div class="portfolio-overview-page__content">
            <div class="portfolio-overview-page__content__master-data-latest-grid">
                <div class="portfolio-overview-page__content__master-data-latest-grid__status-summary">
                    <PortfolioOverviewStatusSummary
                        :description="t('generators.portfolioOverview.portfolioStatusSummary.numberOfGenerators')"
                        :use-status-summary-query="useGeneratorsPortfolioStatusSummaryQuery"
                    />
                </div>
                <PortfolioOverviewFlaggedGenerators />
            </div>
            <div class="portfolio-overview-page__content__master-data-latest-grid">
                <div class="portfolio-overview-page__content__master-data-latest-grid__chart-summary">
                    <PortfolioOverviewGroupSummary @click:group="onClickGroup" />
                </div>
                <div class="portfolio-overview-page__content__master-data-latest-grid__chart-summary">
                    <PortfolioOverviewPlantStatusSummary
                        :plant-group-sid-param="plantGroupSid"
                        @reset:group="onResetGroup"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import PortfolioOverviewStatusSummary from '@/pages/common/portfolio-overview/PortfolioOverviewStatusSummary.vue'
import PortfolioOverviewGroupSummary from '@/pages/generators/portfolio-overview/PortfolioOverviewGroupSummary.vue'
import PortfolioOverviewFlaggedGenerators from '@/pages/generators/portfolio-overview/PortfolioOverviewFlaggedGenerators.vue'
import PortfolioOverviewPlantStatusSummary from '@/pages/generators/portfolio-overview/plant-status-summary/PortfolioOverviewPlantStatusSummary.vue'
import { useGeneratorsPortfolioStatusSummaryQuery } from '@/api/queries/generators/portfolio-overview/useGeneratorsPortfolioStatusSummaryQuery'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

const { t } = useI18n()

const plantGroupSid = ref<number | undefined>(undefined)

const onClickGroup = (value: number) => {
    plantGroupSid.value = value
}

const onResetGroup = () => {
    plantGroupSid.value = undefined
}
</script>

<style scoped lang="scss">
.portfolio-overview-page {
    @include spacing-page;

    overflow-y: scroll;
    max-height: calc(100vh - $navbar-height * 2);

    display: flex;
    flex-direction: column;
    gap: $spacing-m;

    &__title {
        font-size: 1.25rem;
        font-weight: 500;
    }

    &__content {
        display: flex;
        flex-direction: column;

        gap: $spacing-m;

        &__master-data-latest-grid {
            display: flex;
            gap: $spacing-m;

            &__status-summary {
                min-width: 25%;
            }

            &__chart-summary {
                width: 50%;
            }
        }
    }
}
</style>
